import { AreaResource, AreaType } from '../../area.resource';
import { CommessaResource } from './commessa.resource';
import { CdcResource } from './cdc.resource';

export class AreaTempozeroResource extends AreaResource {
  public static readonly TYPE = AreaType.tempozero;

   type_user: UserOfAtzTypeResource;
   personal_approval_power: number;
   commesse: CommessaResource[];
   cdc: CdcResource[];
   notes: string;
   cm_riferimento : any;
   cdc_associated : CdcAssociated[] | null;

   constructor() {
    super(AreaTempozeroResource.TYPE);

}}


export class CdcAssociated {
  enabled_disabled:boolean;
  value:string;
}


export class UserOfAtzTypeResource  {
  id: number;
  type: string;
  description: string;
  link?:any;
}